import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb } from 'dash-ui';

import { BreadcrumbContext } from 'common/contexts/breadcrumb-context/breadcrumb-context';

function BreadcrumbNavigation() {
  const navigate = useNavigate();
  const { breadcrumbItems } = useContext(BreadcrumbContext);

  return (
    <Breadcrumb
      limit={7}
      onNavigate={(route) => navigate(route)}
      items={breadcrumbItems}
    />
  );
}

export default BreadcrumbNavigation;
